// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2csad","overflowing":"ReadFullNote_overflowing__V6ziB"};